export default "__VITE_ASSET__CIhNe43s__"